<!-- 
  Notes to QA
  - Mobile phone number has moved to the contact info slider (used to be called with the #id header-cbg-call)
-->

<div class="glo-questionnaire-header" *ngIf="{logoTitle: 'Legalzoom' } as scope">
  <!-- Fixed Header -->
  <div class="glo-questionnaire-header-wrapper w-100 glo-questionnaire-header-wrapper-fixed" [style.max-width]="'auto'">
    <div class="glo-questionnaire-header-container container-fluid container-md h-100" *ngIf="isLocalHeader">
      <div class="row h-100">

        <div class="col-12">
          <div class="d-flex align-items-center justify-content-center h-100 w-100">
            <!-- Logo -->
            <a class="glo-link-plain glo-questionnaire-header-logo">
              <!-- Desktop/Tablet -->
              <div class="d-none d-md-inline-block" (click)="goHomepage()" style="cursor:pointer;">
                <svg class="glo-questionnaire-header-svg-logo">
                  <title>{{ scope.logoTitle }}</title>
                  <use href="assets/sprite.view.svg#glo-legalzoom"></use>
                </svg>
              </div>
              <!-- Mobile -->
              <!-- @todo on click, open contact info slider-->
              <div class="d-inline-block d-md-none" (click)="goHomepage()">
                <svg class="glo-questionnaire-header-svg-logo-mobile">
                  <title>{{ scope.logoTitle }}</title>
                  <use href="assets/sprite.view.svg#glo-legalzoom-mobile"></use>
                </svg>
              </div>
            </a>

            <!-- Spacer -->
            <div class="flex-grow-1"></div>

            <!-- Desktop/Tablet - Phone -->
            <a class="glo-link-plain d-none d-md-block phone-btn" [href]="deskPhoneNum | formatPhone:'link'">
              <svg class="glo-questionnaire-header-svg-phone m-0" viewBox="0 0 24 24">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
                  <g stroke="currentColor" stroke-width="2">
                    <path
                      d="M14.302754,16.2932565 L16.5019672,14.0950343 L22,15.1941454 L22,21.788812 C19.7097503,22.3335057 13.6530841,22.238546 7.7051146,16.2932565 C1.75714508,10.3479671 1.66695701,4.28921771 2.21189621,2 L8.80953563,2 L9.9091422,7.49555548 L7.70992906,9.69377767 C8.43922544,11.1602978 9.35350351,12.4437425 10.4527633,13.5441117 C10.6861226,13.7777065 11.25005,14.2829883 11.5,14.5">
                    </path>
                  </g>
                </g>
              </svg>
              <span class="ml-2">{{ deskPhoneNum | formatPhone }}</span>
            </a>

            <!-- Buttons that only show up when SAVING is allowed -->
            <ng-container *ngIf="userHasCart()">
              <ng-container *ngIf="!isGuest()">
                <!-- Logout -->
                <a class="glo-link-plain d-none d-md-block glo-questionnaire-header-logout glo-cursor-pointer"
                  id="lnk-logout" (click)="logout()">
                  <span>Log out</span>
                </a>
              </ng-container>

              <ng-container *ngIf="isGuest()">
                <!-- Save: Mobile -->
                <button *ngIf="mobile"
                  class="btn btn-sm btn-outline d-block d-md-none glo-questionnaire-header-save-progress"
                  id="lnk-save-progress" (click)="saveYourWork()">
                  <span>Save</span>
                </button>
                <!-- Save: Desktop Tablet -->
                <button *ngIf="!mobile" id="lnk-save-progress"
                  class="btn btn-outline d-none d-md-block glo-questionnaire-header-save-progress"
                  (click)="saveYourWork()">
                  <span>Save progress</span>
                </button>
              </ng-container>
            </ng-container>

            <!-- Mobile - Contact -->
            <button class="d-md-none btn btn-sm glo-questionnaire-header-contact-us" (click)="contactInfoSlider.open()">
              <span>Contact us</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <gc-pl-header *ngIf="!isLocalHeader"></gc-pl-header>

    <div class="glo-questionnaire-header-progress-bar" [ngClass]="progressPercentage"></div>
  </div>
</div>


<app-contact-info-slider #contactInfoSlider [phoneNumber]='mobilePhoneNum'></app-contact-info-slider>
